<!--
  ~ Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="head">
  <h1 *ngIf="isNieuw">Nieuwe functie</h1>
  <h1 *ngIf="! isNieuw">{{orig?.naam}}</h1>
</div>
<div class="content">
  <form #form='ngForm'>
    <div class="form-group">
      <label [for]="id('naam')">Functie</label>
      <input type="text" [id]="id('naam')" name="naam" autofocus class="form-control" minlength="2" maxlength="100" required
             [(ngModel)]="record.naam"
             spellcheck="false">
    </div>
    <div class="form-group">
      <label [for]="id('kleur')">Kleur</label>
      <div [id]="id('kleur')" [(colorPicker)]="record.kleur" [cpToggle]="true"
           cpFallbackColor="#FFFFFF" cpDialogDisplay="inline"
           [cpDisableInput]="true" cpWidth="382"
           cpAlphaChannel="disabled" cpOutputFormat="hex"
          (colorPickerChange)="form.form.markAsDirty()"
      ></div>
    </div>
    <div class="form-group">
      <label [for]="id('opmerkingen')">Opmerkingen</label>
      <textarea class="form-control" [id]="id('opmerkingen')" name="opmerkingen" [(ngModel)]="record.opmerkingen"></textarea>
    </div>
  </form>
</div>
<div class="foot">
  <div class="buttons" links>
    <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
    <button class="btn btn-danger ml-auto" (click)="delete()" *ngIf="! readonly && ! isNieuw"
            [disabled]="! kanVerwijderen"
            [attr.title]="kanVerwijderen? 'Verwijder deze functie' : 'Deze functie kan niet verwijderd worden, omdat ernaar wordt verwezen. Wel kan hij inactief gemaakt worden.'">
      Verwijderen
    </button>
  </div>
  <div class="buttons" rechts>
    <button class="btn btn-primary" (click)="save()" *ngIf="! (readonly || shouldReload)"
            [disabled]=" form.invalid || form.pristine">
      Opslaan
    </button>
    <button class="btn btn-warning" (click)="reload()" *ngIf="shouldReload">Herladen (gewijzigd)</button>
  </div>
 </div>
